import { render, staticRenderFns } from "./ReminderBanner.vue?vue&type=template&id=48596e62&scoped=true&"
import script from "./ReminderBanner.vue?vue&type=script&lang=js&"
export * from "./ReminderBanner.vue?vue&type=script&lang=js&"
import style0 from "./ReminderBanner.vue?vue&type=style&index=0&id=48596e62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../nonspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48596e62",
  null
  
)

component.options.__file = "ReminderBanner.vue"
export default component.exports